import { PrivacyPolicyContent } from '@/components/privacyPolicy/PrivacyPolicyContent';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/privacyPolicy';
import { DocumentTypes } from 'contentlayer/generated';
import type React from 'react';

interface PrivacyPolicyPageTemplateProps {
  config: Config;
  showHeader?: boolean;
  showFooter?: boolean;
}

export const PrivacyPolicyPageTemplate: React.FC<PrivacyPolicyPageTemplateProps> = ({
  config,
  showHeader,
  showFooter,
}) => {
  useShowHeaderCtaOnScroll(true);

  return (
    <Layout
      pt={[70, 60, 120]}
      headerActions={config.layout.headerActions}
      showHeader={showHeader}
      showFooter={showFooter}
    >
      <SEO {...config.seo} />
      <PageWrapper maxWidth={1000} px={20} mx="auto" pb={40}>
        <PrivacyPolicyContent content={config.MDXContent as DocumentTypes} />
      </PageWrapper>
    </Layout>
  );
};
